var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RefundReportPage"},[_c('ReportTable',{attrs:{"col-def":_vm.columnDefs,"api":"employee-refund","search-filter":"refund"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }